import { z } from 'zod';
import { personalDataResource } from '@/api/resources';

export const customerStateSchema = z.object({
	personal: personalDataResource,
	terms: z.boolean(),
	comment: z.string().nullable(),
	authentication: z.object({
		action: z.enum(['guest', 'register', 'login']),
		access_token: z.string().nullable(),
		email: z.string().nullable(),
		password: z.string().nullable(),
		password_confirmation: z.string().nullable(),
	}),
});

export type CustomerStoreState = z.infer<typeof customerStateSchema>;
